module.exports = __webpack_public_path__ + "img/typewriters-frame.2248a0cb.gif";